import { render } from "./B2bTableMenuGenralsReceived.vue?vue&type=template&id=1efb4948&scoped=true&lang=pug"
import script from "./B2bTableMenuGenralsReceived.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuGenralsReceived.vue?vue&type=script&lang=js"

import "./B2bTableMenuGenralsReceived.vue?vue&type=style&index=0&id=1efb4948&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1efb4948"]])

export default __exports__